import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tecnologia } from 'src/app/models/Tecnologia';
import { TecnologiasService } from '../../shared/services/tecnologias.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CatalogService } from '../../shared/services/catalog.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { getCatalogErrorMessages } from 'src/app/constants/catalog-error-messages';


@Component({
  standalone: false,
  selector: 'app-tech-dialog',
  templateUrl: './tech-dialog.component.html',
  styleUrls: ['./tech-dialog.component.css']
})
export class TechDialogComponent implements OnInit {
  @ViewChild('techNameSelect') techNameSelect: any;

  variables: any;

  tecnologias: Tecnologia[] = []; //List of predefined technologies
  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.
  invalidInput: boolean = false;
  invalidInput1: boolean = false;
  invalidInput2: boolean = false;
  invalidInput3: boolean = false;
  invalidInput4: boolean = false;

  errorMessage = '';
  errorMessage1 = '';
  errorMessage2 = '';
  errorMessage3 = '';
  errorMessage4 = '';

  errorMessages: any;

  formGroup1: any;

  regions: any = [];
  allRegions: any = [];
  allTechs: any = [];
  catalogs: any[] = [];
  filteredCatalogs: any[] = [];
  importedCatalog: any = '';

  cecos: any = [];
  costCenters: any = [];

  errorDetected: boolean = false;
  errorText: string = "";
  isLoading: boolean = true;


  filteredCostCenters: any[] = [];
  searchForm!: FormGroup;
  costCentersFilterCtrl: FormControl = new FormControl();

  constructor(
    private tecnologiasService: TecnologiasService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    public dialogRef: MatDialogRef<TechDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private GCMService: GCMService,
    private infoBar: InfoBarWithStatusService,
    private TechnologiesManagementService: TechnologiesManagementService,
    private catalogService: CatalogService
  ) {
    this.local_data = { ...data }; //retrieve data

  }

  ngOnInit(): void {

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup1 = this.formBuilder.group({
      techCtrl: new FormControl('', Validators.required),
      catalogNameCtrl: new FormControl('', Validators.required),
      importCtrl: new FormControl(null),

    });

    this.formGroup1.get('techCtrl')?.valueChanges.subscribe((selectedTechnologyId: any) => {
      this.applyCatalogTechnologyFilter(selectedTechnologyId);
    });

    this.getAllActiveTechs();
    this.getAllCatalogs();


    this.errorMessages = getCatalogErrorMessages(this.variables);
  }

  getAllActiveTechs() {
    this.isLoading = true;

    this.TechnologiesManagementService.getAllActiveTechnologies().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;

        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.allTechs = data;
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.allTechs && !this.errorDetected) {
          this.isLoading = false;
        }
      }
    });
  }

  getAllCatalogs() {
    this.catalogService.getAllCatalogs().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error; // Exceeded retry attempts, propagate error
            }
            return retryCount + 1;
          }, 0),
          delay(2500) // Delay between retries (2.5 seconds)
        )
      ),
      catchError(err => {
        console.error('Error fetching techs:', err);
        this.errorDetected = true;

        const message = this.errorMessages[err.error.message]
        this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          this.catalogs = Array.isArray(data) ? data : [];
          this.loadCatalogTechnologyFromDetails();
          this.applyCatalogTechnologyFilter(this.formGroup1?.get('techCtrl')?.value);
        } catch (err) {
          console.error('Error processing data:', err);
          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.catalogs && !this.errorDetected) {
          this.isLoading = false;
        }
      }
    });
  }

  private loadCatalogTechnologyFromDetails() {
    if (!Array.isArray(this.catalogs) || this.catalogs.length === 0) {
      this.filteredCatalogs = [];
      return;
    }

    let pendingRequests = this.catalogs.length;

    this.catalogs.forEach((catalog: any) => {
      if (!catalog?.id) {
        pendingRequests -= 1;
        if (pendingRequests === 0) {
          this.applyCatalogTechnologyFilter(this.formGroup1?.get('techCtrl')?.value);
        }
        return;
      }

      this.catalogService.getCatalogById(catalog.id).subscribe({
        next: (catalogDetails: any) => {
          catalog.technologyId = catalogDetails?.technologyId;
          catalog.techName = catalogDetails?.techName;
        },
        error: (error) => {
          console.error('Error fetching catalog details:', error);
        },
        complete: () => {
          pendingRequests -= 1;
          if (pendingRequests === 0) {
            this.applyCatalogTechnologyFilter(this.formGroup1?.get('techCtrl')?.value);
          }
        }
      });
    });
  }

  private applyCatalogTechnologyFilter(selectedTechnologyId: any): void {
    const selectedId =
      selectedTechnologyId !== undefined && selectedTechnologyId !== null && selectedTechnologyId !== ''
        ? String(selectedTechnologyId)
        : '';

    this.filteredCatalogs = selectedId
      ? this.catalogs.filter((catalog: any) => String(catalog?.technologyId || '') === selectedId)
      : [...this.catalogs];

    const selectedImportId = this.formGroup1?.get('importCtrl')?.value;
    const importStillAvailable = this.filteredCatalogs.some((catalog: any) => catalog?.id === selectedImportId);

    if (!importStillAvailable) {
      this.formGroup1?.get('importCtrl')?.setValue(null);
      this.importedCatalog = '';
    }
  }


  filterCostCenters(searchTerm: string) {
    if (!this.costCenters || this.costCenters.length === 0) {
      return;
    }

    let search = searchTerm ? searchTerm.toLowerCase() : '';


    if (!search) {
      this.filteredCostCenters = [...this.costCenters]; // Clone the array using spread operator
      return;
    }

    this.filteredCostCenters = this.costCenters.filter((costCenter: any) => {
      // Check if costCenter and costCenter.codeName are defined before accessing their properties
      return costCenter && costCenter.toLowerCase().includes(search);
    });

  }



  //Reset radio group
  resetRadio(selectedCatalogId?: any) {
    const currentSelection = this.formGroup1.controls['importCtrl'].value;
    const nextSelection = currentSelection === selectedCatalogId ? null : selectedCatalogId;

    this.formGroup1.controls['importCtrl'].setValue(nextSelection);
    this.importedCatalog = nextSelection ?? '';
  }

  //Set local data and pass back to parent.
  doAction() {

    if (this.formGroup1.invalid) {
      this.formGroup1.markAllAsTouched();
      return;
    }
    if (this.formGroup1.valid) {

      this.catalogService.addNewCatalog(this.formGroup1.value.techCtrl, this.formGroup1.value.catalogNameCtrl, this.formGroup1.value.importCtrl).subscribe
        ({
          next: (data) => {
            if (data) {
              const createdCatalogId = data.id || data.catalogID || data.catalogId || data._id;
              this.dialogRef.close({ data: { success: true, createdCatalogId } });
            }
          },
          error: (error) => {
            console.error('Error:', error.error);

            const message = this.errorMessages[error.error.message]
            this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
          }
        });
    }
  }

  onChange() {
    this.invalidInput = false;
  }

  onTechNameChange() {
    this.invalidInput = false;

    let searchFilter = this.local_data.techName.trim().toLowerCase();

    this.allTechs = this.local_data.technologies.filter((tech: any) => tech.name.toLowerCase().includes(searchFilter));


    if (this.allTechs.length === 0) {
      this.allTechs = this.local_data.technologies;
    }

    this.techNameSelect.open();

  }

  changeRegion(value: any) {
    this.invalidInput1 = false;
    this.local_data.region = value;
  }

  changeTech(value: any) {
    this.invalidInput2 = false;
    this.local_data.tech = value.name;
  }

  changeCostCenter(value: any) {
    this.invalidInput4 = false;
    this.local_data.costCenter = value;
  }

}
